/**
 * @generated SignedSource<<dc26eea0ddc69070ac73ea26c6f9e243>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type refundHistoryQuery$variables = Record<PropertyKey, never>;
export type refundHistoryQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly name: string | null | undefined;
      readonly refundDetail: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly applicationInfo: {
          readonly accountNo: string | null | undefined;
          readonly bank: string | null | undefined;
        } | null | undefined;
        readonly businessInfo: {
          readonly hometaxBizName: string | null | undefined;
          readonly hometaxBizNo: string | null | undefined;
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly corpType: string;
        readonly id: string;
        readonly paymentAmount: number | null | undefined;
        readonly paymentDate: string | null | undefined;
        readonly refundAmount: string;
        readonly refundResultDt: string | null | undefined;
      }> | null | undefined;
    };
  };
};
export type refundHistoryQuery = {
  response: refundHistoryQuery$data;
  variables: refundHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BznavRefundOutput",
    "kind": "LinkedField",
    "name": "bznavRefund",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RefundUserType",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundHistoryType",
            "kind": "LinkedField",
            "name": "refundDetail",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "corpType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ApplicationInfo",
                "kind": "LinkedField",
                "name": "applicationInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bank",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountNo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refundAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BusinessInfo",
                "kind": "LinkedField",
                "name": "businessInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hometaxBizName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hometaxBizNo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxpayerName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refundResultDt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationDt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "refundHistoryQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "refundHistoryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f2148ba985436bfd11a2a4b827c4ead6",
    "id": null,
    "metadata": {},
    "name": "refundHistoryQuery",
    "operationKind": "query",
    "text": "query refundHistoryQuery {\n  bznavRefund {\n    user {\n      name\n      refundDetail {\n        id\n        corpType\n        applicationInfo {\n          bank\n          accountNo\n        }\n        refundAmount\n        paymentDate\n        paymentAmount\n        businessInfo {\n          hometaxBizName\n          hometaxBizNo\n          taxpayerName\n        }\n        refundResultDt\n        applicationDt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "367d272074036bc169cf99f0562a46b0";

export default node;
